import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Filter } from "./filter.model";

@Injectable()
export class FilterService extends CrudService {
  getRootUrl(): string {
    return "filters";
  }

  save(filter: Filter) {
    return super.save(filter);
  }

  saveMultiple(filters: Array<Filter>) {
    return super.saveMultiple(filters);
  }

  getByCategory(category: string) {
    return this.http
      .get(`/${this.rootUrl}/category/id/${category}`)
      .map(this.http.getJsonData);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/shared/filter.service.ts